import store from "@/store";
export const viewHash = hash => {
  window.open(store.state.netWorkConfig.blocsUrl + hash);
};

export const viewToken = address => {
  window.open(store.state.netWorkConfig.blocsHashUrl + address);
};
